import React from 'react'
import { Box } from '@mui/material'
import { FxInfo } from '../info/FxInfo'
import { FxLabelProps } from './FxLabel.props'

/**
 *
 * @param label
 * @param info
 * @param validations
 * @constructor
 */
export const FxLabel = ({
  label,
  info,
  validations
}: FxLabelProps) => {

  const isMandatory = () => {
    if (validations && validations.length > 0) {
      return validations.includes('required')
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', fontSize: "14px", color: "#666", pb: 1, fontWeight: 600 }}>
      <span>{label}</span>{isMandatory() && <span className="required"></span>}
      {info && <Box sx={{ px: 1 }}><FxInfo {...info} /></Box>}
    </Box>
  )
}
